"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/* eslint-disable */
exports.default = {
  exam: {
    practice: "Exercice indépendant",
    notRegister: "Non inscrit",
    examHours: "Durée ",
    reRegistration: "Retirer l'inscription",
    prevPrevious: "Question précédente",
    accuracy: "Taux correct",
    reviewAudit: "En cours de révision",
    participant: "Inscrivez-vous pour",
    wrongQuestion: "Mauvaise banque de questions",
    auditNoPass: "L'audit a échoué",
    involvement: "A participé",
    submitAnswers: "Soumettre la réponse",
    continuePracticed: "Continuez à pratiquer",
    examination: "Inscrivez-vous à l'examen",
    toFavorite: "Ajouter une collection",
    knowledgeCompetition: "Concours de connaissances",
    questionsAnalysis: "Résolution des questions",
    noInvolvement: "Pas de participation",
    answerWarning: "Le sujet de cet examen est irréversible, s'il vous pla?t soyez prudent avant la question suivante.",
    problemPoints: "Résolution du point de question",
    searchExamPractice: "Recherchez les examens et les exercices qui vous intéressent",
    topics: "Sujet ",
    nextPrevious: "Question suivante",
    participanted: "Déjà inscrit",
    startPractice: "Commencez à pratiquer",
    inputAnswerTips: "Veuillez saisir votre réponse",
    yourAnswers: "Votre réponse",
    rightAnswers: "La bonne réponse",
    noAnalysis: "Pas de résolution pour le moment",
    registration: "Inscription réussie",
    examTime: "Temps d'examen",
    practiced: "Exercice effectué"
  },
  play: {
    chapter: "Chapitre.",
    note: "Notes",
    chapterText1: "Numéro un",
    closeOrNot: "Fermer la fenêtre courante",
    notShowAgain: "Ne plus demander ce message",
    gotIt: "Je sais",
    evaluateStar: "L' étoile",
    noteBlockTitle: "Notes",
    chapterText2: "S'affiche dans la cellule",
    closeTips: "Il se peut que vos modifications ne soient pas enregistrées",
    tips: "Conseils chaleureux",
    autoStopTips: "Comme vous n'avez pas opéré depuis longtemps, le système arrête automatiquement la lecture vidéo.",
    autoStop: "Arrêter automatiquement la lecture",
    noCoursePlay: "Aucun didacticiel n'est disponible pour le cours en cours",
    closeButton: "Va-t' en",
    playTips: "Conseil chaleureux : pour s ’ assurer que votre temps d ’ étude est enregistré correctement par le système, Veuillez cliquer sur le bouton ? terminer l ’ étude ? dans le coin supérieur droit pour quitter l ’ étude. si vous fermez directement le navigateur, votre temps d ’ étude risque de ne pas être enregistré correctement.",
    saveEvaluate: "Soumettre",
    notePlaceholder: "Veuillez saisir une note",
    confirmOut: "Voulez -vous vraiment quitter la lecture & # 160;?",
    evaluate: "évaluation",
    endStudy: "Terminer l'apprentissage"
  },
  questionnaire: {
    shortQuestion: "Questions simples",
    newLine: "Ajouter une ligne",
    topics: "Sujet",
    submitTips: "Vous avez soumis le questionnaire avec succès et merci pour votre participation.",
    save: "Enregistre",
    multiple: "Questions à choix multiple",
    description: "Description du questionnaire",
    sort: "Numéro de série",
    handed: "Remettre le volume",
    tableQuestions: "Titre du formulaire",
    printing: "Imprimer",
    content: "Contenu",
    inputContent: "Veuillez saisir votre réponse",
    submitSuccess: "Soumission réussie",
    single: "Questions à choix unique",
    examList: "Liste des questions",
    deleteLine: "Supprimer une ligne",
    saveSuccess: "Enregistrement réussi",
    notParticipat: "Pas de participation",
    closePage: "Fermez cette page",
    export: "Exporter"
  },
  index: {
    userInfo: "Centre personnel",
    operateConfig: "Cette opération a été rejetée par le navigateur. pour activer cette fonction, entrez about:config dans la barre d'adresse, puis donnez à l' élément signed.applets.codebase _ principal _ support la valeur true",
    ExitSystem: "Quitter le système",
    continueStudy: "Continuez",
    uploadError: "Le téléchargement a échoué",
    homePage: "Page d'accueil",
    studentRanking: "Classement des apprenants",
    required: "Cet élément est obligatoire",
    faceHours: "Temps d'apprentissage en face-à-face",
    recommendCourse: "Cours recommandés",
    checkAllNotice: "Afficher tout",
    startStudy: "Commencez",
    coverImage: "Image de couverture",
    onlineHours: "Temps d'apprentissage en ligne",
    coursesRanking: "Classement des cours",
    faceCourse: "Cours de formation en face-à-face",
    requiredCourses: "Cours obligatoires",
    wecome: "Bienvenue!",
    hotCourse: "Cours les plus chauds",
    favoriteTips: "En raison des limitations fonctionnelles du navigateur 360, appuyez sur Ctrl+D pour la collection manuelle!",
    currentHead: "Avatar actuel",
    telephone: "Téléphone de consultation",
    noMessage: "Aucune donnée n'est disponible pour le moment",
    backToTopButton: "Retour en haut",
    fullScreen: "Affichage en plein écran",
    examPractice: "Exercices d'examen",
    autoFavorite: "Votre navigateur n'est pas pris en charge, Veuillez appuyer sur Ctrl+D pour la collection manuelle!",
    newCourse: "Dernier cours",
    currentUser: "Utilisateur actuel",
    trainingTime: "Temps de formation",
    setAsHomePage: "Définir comme page d'accueil",
    currentPhone: "Téléphone portable actuel",
    SystemMessage: "Alertes système",
    Help: "Centre d'aide",
    encryPhone: "Téléphone protégé",
    backToTop: "Retour en haut",
    back: "Revenir en arrière",
    courseCategory: "Classe de cours",
    head: "L'avatar",
    emptyMessage: "Vide.",
    userHead: "Avatar de l'utilisateur",
    top: "Haut ",
    allCourses: "Tous les cours",
    checkAllMessage: "Afficher tout",
    course: "Cours de formation",
    onlineCourse: "Cours thématiques en ligne",
    dataDownLoad: "Téléchargement de ressources",
    coursehours: "Temps d' étude",
    human: "Les gens",
    notice: "Avis de notification",
    Administration: "Gestion de l'arrière-plan",
    change: "Modifier ",
    message: "Message ",
    userName: "Nom d'utilisateur",
    autoSetHomeTips: "La configuration automatique de la page d'accueil n'est pas prise en charge par votre navigateur. Veuillez la configurer manuellement à l'aide du menu du navigateur!",
    examIsOver: "L' évaluation est terminée",
    impotentCourse: "Cours clés",
    electiveCourses: "Cours au choix",
    addCollection: "Ajouter des favoris",
    to: "à ",
    accountPassword: "Mot de passe du compte"
  },
  course: {
    courseYear: "Année",
    examLog: "Dossier d'examen",
    noDesc: "Pas d'introduction pour le moment",
    noPublicExam: "Ce test ne sera pas publié",
    coursesCategory: "Classe de cours",
    checkLog: "Affichage des enregistrements",
    viewPaper: "Afficher le papier test",
    newComment: "Le plus récent",
    emptyCommentTips: "Le commentaire ne peut pas être vide",
    continueStudy: "continuer",
    courseData: "Documentation du cours",
    donwButton: "Bas &nbsp ; - oui",
    relatedCourses: "Cours connexes",
    score: "Points ",
    startStudy: "Début",
    closeButton: "Fermer ",
    typeOuth: "Autre chose",
    up: "Page précédente",
    courseInfo: "Détails du cours",
    requiredCourses: "Cours obligatoires",
    examResultPage: "Page résultats du test",
    examPage: "Page d'examen",
    noteSource: "De ",
    item: "S'ouvre alors",
    cancelCollect: "Annuler la collection",
    searchTips: "Veuillez saisir un nom de cours",
    count: "Au total",
    courseExamination: "Avec l'examen de classe",
    studentsNum: "Nombre de cours sélectionnés",
    startExam: "Commencez l'examen",
    JoinLearning: "Rejoignez l'apprentissage",
    publishButton: "Publier ",
    uploadDate: "Heure de téléchargement ",
    typeDoc: "Documentation ",
    resourceSize: "Taille de la ressource",
    hotComment: "Le plus chaud",
    page: "Dans la barre d'outils standard",
    collect: "Collection ",
    items: "Article / page",
    evaluate: "évaluation ",
    isEvaluate: "A été évalué",
    cancelTips: "Confirmer l'annulation de l'invite",
    next: "Page suivante",
    preview: "Aper?u ",
    no: "Numéro un",
    chapter: "S'affiche dans la cellule",
    reExam: "Nouvel examen",
    className: "Nom de la classe",
    donwNum: "Nombre de téléchargements ",
    confirmButton: "Bouton annuler",
    courseEvaluate: "évaluation des cours",
    needIETips: "Le didacticIEl actuel nécessite le navigateur ie!",
    times: "Le deuxième",
    cancelButton: "Annuler ",
    teachersDesc: "Introduction à l'enseignant",
    allCourses: "Tous les cours",
    commentTips: "Veuillez saisir un commentaire",
    courseNote: "Notes de cours",
    man: "Les gens",
    coursehours: "Temps d' étude",
    openComment: "Je veux faire un commentaire",
    cancelConfirm: "Annuler la collection",
    go: "Aller à",
    typeImages: "Plusieurs images",
    courseTeachers: "Professeur ",
    typeViedo: "Vidéo ",
    courseHours: "Heures de cours",
    marking: "Pendant le défilé",
    electiveCourses: "Cours au choix",
    deleteNoteButton: "supprimer",
    courseChapter: "Chapitre du cours",
    typeImage: "Image "
  },
  offlineclass: {
    evaluateTime: "Temps d' évaluation",
    partySchool: "Cours de formation à l' école du parti",
    seven: "Jour de la journée",
    passedState: "état de passage",
    sureDelete: "êtes-vous s?r de vouloir supprimer?",
    askLeave: "Je veux prendre congé",
    three: "Trois.",
    photos: "Album photo ",
    sickLeave: "Congé de maladie",
    phontoRequier: "Les photos doivent passer",
    uploadPhoto: "Téléchargement de photos",
    learningActivity: "Activités d'apprentissage",
    seeRecord: "Affichage des enregistrements",
    leaveType: "Type de congé",
    inputReasonLeave: "Veuillez saisir un motif de congé",
    beDoing: "En cours d'exécution",
    classHours: "Heures de classe",
    five: "Cinq.",
    notEvaluation: "Non évalué",
    reasonLeave: "Motif du congé",
    inputPhotoName: "Veuillez saisir un nom de photo",
    group: "L' équipe",
    leaveTime: "Temps de congé",
    examPage: "Page d'examen",
    formatSupport: "Prise en charge des formats",
    sure: "Ok.",
    resultPage: "Page résultats du test",
    saturdays: "Samedi.",
    selectTime: "Sélectionnez l' heure",
    onlineToFace: "Sur le terrain",
    photoCategory: "Catégorie d'album ",
    is: "Oui.",
    startLearn: "Entrez dans l'apprentissage",
    firstWeek: "Semaine 1",
    photoName: "Nom de la photo",
    morning: "Le matin",
    sunday: "Dimanche.",
    at: "Dans ",
    photoMessage: "Informations photographiques",
    fullTimeToFace: "Délivrance de nouilles hors production",
    phoneIsOccur: "Le nom de la photo existe déjà",
    evaluating: "évaluation ",
    longNotBits: "La longueur ne doit pas dépasser 50 caractères",
    hoursStandard: "L' heure de l' école n'est pas conforme à la norme et ne peut pas passer l'examen",
    evalueteNotStar: "L' évaluation n'a pas commencé",
    submitFailure: "échec de la livraison",
    examRecord: "Dossier d'examen",
    seeSubmite: "Afficher le papier test",
    questionnaire: "Questionnaire d'enquête",
    tickets: "Zhang.",
    submit: "Soumettre ",
    for: "Quatre.",
    notStarted: "N'a pas commencé",
    coursesTaught: "Cours dispensés",
    notGroup: "Non groupé",
    evaluateEnds: "L' évaluation est terminée",
    classEvaluation: "évaluation de la classe",
    searchPartySchool: "Recherchez les cours de formation de l' école du parti qui vous intéressent",
    two: "Deux.",
    fridays: "Vendredi.",
    startEvaluation: "Commencez l' évaluation",
    isEvaluated: "évalué ( e )",
    groupTalk: "Groupes de discussion",
    openClass: "Classe ouverte",
    not: "Non.",
    teacherAbout: "Introduction à l'enseignant",
    addPhoneTips: "Ajout réussi, Veuillez attendre la révision",
    phoneNameReq: "Nom de la photo obligatoire",
    deleteSuccess: "Suppression réussie",
    inputIdea: "S'il vous pla?t entrer vos pensées",
    wednesday: "Mercredi.",
    evaluationStartTime: "Heure de début de l' évaluation",
    passed: "Adopté ",
    casualLeave: "Les vacances",
    monday: "Lundi.",
    six: "Six.",
    one: "Un.",
    h: "Dans la barre d'outils",
    selectLeaveType: "Veuillez sélectionner un type de congé",
    clear: "Vide.",
    thursday: "Jeudi.",
    selctLeaveTime: "S'il vous pla?t choisir le temps de congé",
    inputEvaluating: "Veuillez saisir le contenu de l' évaluation",
    addPhoto: "Ajouter une photo",
    afternoon: "Dans l'après-midi",
    courseEvaluation: "évaluation pédagogique",
    seeEvalute: "Afficher les évaluations",
    tuesday: "Mardi.",
    teacherTech: "Cours re?us",
    searchThoseClass: "Recherchez les cours de formation en face-à-face qui vous intéressent",
    allClass: "Toutes les classes",
    evening: "La nuit",
    sketch: "Projet de texte",
    evaluationInProgress: "évaluation en cours"
  },
  onlineclass: {
    notBeginClass: "Pas de cours",
    reason: "Pourquoi?",
    upload: "Télécharger ",
    downloadHomework: "Télécharger la tache",
    myScore: "Mon score",
    videos: "Vidéo ",
    score: "Marquer ",
    approved: "L'audit a été approuvé",
    elective: "Au choix",
    multiImages: "Plusieurs images",
    endClass: "Classe terminée",
    participating: "A participé",
    hideAllMan: "Réduire tous les apprenants",
    cacheSave: "Mise en ?uvre",
    formatSupport: "Prise en charge du format de fichier",
    images: "Image ",
    examIsPass: "Si l'examen a réussi",
    subjectsNumber: "Nombre de portes",
    startLearn: "Entrez dans la classe",
    classNotStar: "L'inscription à la classe n'a pas encore commencé",
    classTalk: "Discussion de classe",
    nopassed: "Pas encore inscrit",
    leaveMaxBits: "La raison du congé ne peut pas dépasser 100 mots",
    submitTime: "Heure de soumission",
    trainingTime: "Temps de formation",
    notApproved: "Pas d'audit",
    even: "En retard",
    classStudy: "Apprentissage en classe",
    resourceSize: "Taille de la ressource",
    detail: "Détails ",
    downloadCount: "Nombre de téléchargements ",
    electiveStandard: "Temps de conformité au choix",
    clickHere: "Cliquez ici",
    onlineClasses: "Cours thématiques en ligne",
    quantityOfCourses: "Nombre de cours",
    document: "Documentation ",
    compulsoryNumber: "Quantité de passage obligatoire",
    handed: "Remettre le volume",
    hot: "Le plus chaud",
    inputTalkContent: "Veuillez saisir le contenu de la discussion",
    groupTalk: "Table ronde",
    openReservation: "Ouverture de l'inscription",
    noon: "L'après-midi",
    clickReset: "Cliquez sur le bouton pour retirer votre inscription",
    notSubmit: "Non soumis",
    leaveNotEndTime: "L' heure de début du congé ne peut pas être égale à l' heure de fin",
    inforCertificate: "Certificat ",
    close: "Fermer ",
    submitHomework: "Soumettre le travail",
    allTheClass: "Toutes les classes",
    address: "Emplacement ",
    homework: "Les devoirs",
    subjects: "La porte",
    classOvered: "Classe terminée",
    agentRegister: "Inscrivez-vous à nouveau",
    updateTime: "Heure de téléchargement ",
    sizeNot: "La taille ne peut pas dépasser",
    showAllGroup: "Afficher tous les membres de l' équipe",
    searchThoseClass: "Recherchez les cours en ligne qui vous intéressent",
    groupMan: "Chef d' équipe",
    reSubmit: "Soumettre à nouveau",
    subjectsClass: "Cours de porte",
    to: "à ",
    submited: "Soumis ( s )",
    resourceType: "Type",
    registrationTime: "Heure d'inscription",
    numberOfParticipants: "Nombre d'inscriptions",
    cancelRegister: "Annuler l'inscription",
    excellence: "Excellent.",
    source: "Données ",
    compulsoryStandard: "Temps d' étude obligatoire",
    iknow: "Je sais",
    down: "En bas.",
    download: "Télécharger ",
    startExim: "Commencez l'examen",
    electiveNumber: "Nombre de passage facultatif",
    talk: "Discuter de",
    up: "Allez.",
    communication: "Communication ",
    reply: "Répondre ",
    inputReason: "Veuillez saisir un motif de révocation",
    others: "Autre chose",
    faceCourseClass: "Cours de formation en face-à-face",
    hideAllGroup: "Rangez tous les membres de l' équipe",
    courses: "Cours ",
    new: "Le plus récent",
    resource: "Ressources ",
    cancelLike: "Annuler l' éloge",
    classIsEnd: "L'inscription à la classe est terminée",
    delete: "supprimer",
    resetRegister: "Retirer l'inscription",
    classExam: "Examen de classe",
    undo: "Annuler ",
    teacher: "Professeur ",
    showAllMan: "Afficher tous les apprenants",
    noIntroduction: "Pas d'introduction pour le moment",
    notParticipat: "Pas de participation",
    allType: "Tous les types",
    uploadHomework: "Télécharger la tache",
    notice: "Notification ",
    comments: "Commentaires ",
    isDelete: "Confirmer la suppression?",
    registerNow: "Inscrivez-vous maintenant",
    classPassIndicator: "Indicateur de réussite de la classe",
    compulsory: "Obligatoire ",
    beginClass: "Déjà en service",
    allClass: "Tout le monde",
    publish: "Publier ",
    talkTech: "Ma?tre de conférences",
    wantTalk: "Je veux en discuter",
    Learned: "Appris ",
    category: "Classification "
  },
  source: {
    classResource: "Ressources de classe",
    searchResource: "Recherchez les ressources qui vous intéressent",
    previewResource: "Aper?u de la ressource",
    evaluationSuccess: "évaluation réussie",
    allResource: "Toutes les ressources",
    commonResource: "Ressources communes",
    className: "Nom de la classe",
    resourceTalk: "évaluation des ressources",
    resourceEvaluation: "Notation des ressources",
    resourceCategory: "classification",
    helpPoint: "Manuel d'aide",
    isEvaluation: "Vous avez déjà évalué!",
    selectEvaluation: "Vous n'avez pas sélectionné de notation!",
    topRelise: "Haut de gamme"
  },
  login: {
    cancel: "Annuler ",
    resetPassword: "Réinitialiser le mot de passe",
    newPhoneFomat: "Le format du numéro de portable novice est incorrect",
    continueLogin: "Connectez-vous à nouveau",
    passwordBits: "La longueur du mot de passe ne peut pas être inférieure à 6 bits",
    forgetPassword: "Mot de passe oublié",
    sign: "Connectez-vous",
    resetLoginTips: "Votre mot de passe a été modifié avec succès, vous devez vous reconnecter et quitter automatiquement après 3 secondes",
    captchaFail: "La vérification du code de vérification a échoué",
    newPhone: "Numéro de téléphone du débutant",
    logout: "Déconnexion réussie",
    changePhone: "Modifier le numéro de téléphone",
    accountNotEmpty: "Le compte ne peut pas être vide",
    prevStep: "Précédent ",
    poor: "Faible ",
    incorrectTips: "Erreur de saisie du nom d'utilisateur ou du mot de passe",
    surePasswordEmpty: "Vérifiez que le mot de passe ne peut pas être vide",
    orgPhoneEmpty: "Le numéro de téléphone mobile d'origine ne peut pas être vide",
    inputNewPassowrd: "Veuillez saisir un nouveau mot de passe",
    rightMessageChange: "Vous pouvez modifier les informations personnelles sur le c?té droit de la barre de navigation",
    inputAccount: "Veuillez saisir un compte",
    inputPassword: "Entrez votre mot de passe",
    captchaNotEmpty: "Le code de vérification ne peut pas être vide",
    newPhoneSupport: "Le numéro de téléphone novice ne peut pas correspondre au numéro de téléphone mobile d'origine",
    phoneCaptchaEmpty: "Le code de vérification du téléphone ne peut pas être vide",
    sure: "Ok.",
    resetSuccessTips: "Vous avez réinitialisé votre mot de passe avec succès. Veuillez vous connecter",
    copyRight: "Network Communication Cloud Tous droits réservés Numéro d'enregistrement ICP 111111111111",
    phoneEmpty: "Le numéro de téléphone ne peut pas être vide",
    confimPassword: "S'il vous pla?t confirmer le mot de passe",
    inputOrigPassword: "Veuillez saisir le mot de passe d'origine",
    phoneNumber: "Numéro de téléphone",
    nextStep: "étape suivante",
    reset: "Réinitialiser ",
    surePassword: "S'il vous pla?t confirmer le mot de passe",
    formerPhone: "Numéro de téléphone portable d'origine",
    clickGoHome: "Cliquez pour revenir à la page de connexion",
    loginNow: "Connectez-vous maintenant",
    strong: "Fort.",
    confirmNot: "Le mot de passe saisi et le mot de passe de confirmation ne sont pas identiques",
    changePasswordSuccess: "Modification du mot de passe réussie",
    inputUserName: "Veuillez saisir un nom d'utilisateur",
    failTips: "La vérification a échoué",
    changePhoneSuccess: "La modification du numéro de téléphone mobile a réussi",
    orgPhoneFormat: "Le format du numéro de téléphone mobile d'origine est incorrect",
    newPhoneBinded: "Le numéro de machine novice est lié",
    passwordBitsLong: "La longueur du mot de passe ne peut pas être supérieure à 18 bits",
    loginFail: "échec de la connexion, Veuillez réessayer!",
    bingPhone: "Lier le numéro de téléphone",
    accountVerif: "Vérification du compte",
    userNameEmpty: "Le nom d'utilisateur ne peut pas être vide",
    bingPhoneSuccess: "Lier le numéro de téléphone avec succès",
    onlineTraining: "Liao gaoe college plate-forme de formation en ligne",
    middle: "Dans le",
    newPhoneEmpty: "Le numéro de machine novice ne peut pas être vide",
    goHome: "Aller à la page d'accueil",
    resetDone: "Réinitialisation terminée",
    inputCaptcha: "Veuillez saisir un code de vérification",
    phoneBinded: "Le numéro de téléphone est lié",
    changePhoneSuccessTips: "Vous avez modifié le numéro de téléphone avec succès",
    phoneFormat: "Le format du numéro de téléphone mobile est incorrect",
    captchaTips: "Erreur d'entrée de code de vérification",
    changePassword: "Modifier le mot de passe",
    phoneVerif: "Vérification du téléphone",
    passwordFormat: "Les mots de passe sont de 8 à 32 bits et contiennent des chiffres et des lettres majuscules et minuscules",
    passwordNotEmpty: "Le mot de passe ne peut pas être vide",
    getCaptcha: "Obtention du code de vérification",
    orgPhoneNot: "Le numéro de téléphone mobile d'origine est incorrect",
    msgCaptcha: "Code de vérification SMS",
    resetSuccess: "Réinitialisation réussie",
    loginVertif: "Authentification de connexion"
  },
  usercenter: {
    onBusiness: "Parce que le public",
    loginAccount: "Compte de connexion",
    practice: "Exercice",
    courseCollected: "Collection de cours",
    chargeInfo: "Taux de facturation",
    year: "Année",
    onlineCentralizedLearning: "Apprentissage centralisé en ligne",
    otherOptionTips: "Veuillez saisir d'autres informations à ajouter",
    onExam: "L'examen est en cours",
    myScore: "Mon score",
    allHours: "Temps total d' étude",
    phoneWrong: "S'il vous pla?t entrer le numéro de téléphone correct",
    confirmHandExams: "Confirmer la livraison",
    goBackrecommend: "Retour à la recommandation de l'enseignant",
    score: "Points ",
    emptyAnswer: "L'option ou la réponse ne peut pas être vide",
    ongoing: "En cours",
    editTeacher: "Modifier",
    myQuestionnaire: "Mon questionnaire",
    english: "Anglais.",
    faceCourse: "Cours de visage",
    requiredCourses: "Cours obligatoires",
    cancelLeave: "Annuler le congé",
    wrongQuestionBank: "Ma mauvaise banque de questions",
    allTeacher: "Tous les enseignants",
    workUnit: "Unité de service",
    otherInfo: "Informations supplémentaires",
    passedCourse: "Approuvé ",
    onlineSelfLearn: "Apprentissage autonome en ligne",
    ruleString: "Entrez un nombre de caractères inférieur ou égal à 80",
    inExams: "Passer l'examen",
    personal: "Pour des raisons privées",
    completed: "C'est fait",
    confirmCancel: "Confirmez si le congé est annulé",
    checkTeacher: "Afficher",
    rejectReasons: "Motif du rejet",
    junior: "élèves du secondaire",
    passedExam: "L'examen a réussi",
    exam: "L'examen",
    myCollected: "Ma collection",
    fitBusiness: "Adapté à la ligne de service",
    assessmentTime: "Temps d' évaluation",
    handExamsSuccess: "Livraison réussie",
    allCertificate: "Tous les certificats",
    outCompanyLearnHours: "Apprentissage à l'extérieur ( heures d' étude )",
    deleteCollected: "Supprimer la collection",
    searchWrongTips: "Recherchez la mauvaise question qui vous intéresse",
    teachingStyle: "Style de conférence",
    baseInfo: "Informations de base",
    searchExamTips: "Entrez le nom de la recherche",
    eachQuestion: "Chaque question",
    hasCollected: "Collection",
    surplusMakeUpExam: "Examen complémentaire des restes",
    cancelTitle: "Annuler la confirmation",
    teacherNameTips: "Veuillez saisir le nom de l'enseignant",
    underway: "C'est ce que tu fais",
    searchLeaveTips: "Recherchez les vacances qui vous intéressent",
    teacherInfo: "Informations personnelles",
    recommendTeacher: "Recommandé par l'enseignant",
    teacherLocationTips: "Veuillez saisir un lieu de résidence",
    fitLevelTips: "Veuillez sélectionner le niveau de modalité pédagogique approprié",
    pauseSuccess: "Mise en ?uvre réussie",
    faceOutProduceHours: "Perte de production par face ( temps d' étude )",
    auditDate: "Délai d'application",
    teachingExpertiseTips: "Veuillez saisir la spécialité de l'enseignant",
    failedCourse: "échoué ",
    yourScore: "Votre score",
    question: "Question ",
    teacherName: "Nom de l'enseignant",
    needAudit: "En attente d'examen",
    faceTrain: "Formation en face-à-face",
    welcomeMessage: "Je te souhaite du bonheur tous les jours",
    addTeachers: "Ajouter un enseignant",
    checkInfo: "Voir les détails",
    assessmentStatus: "Statut de l' évaluation",
    learningArchives: "Fichier de formation",
    schoolLeader: "Chef d' établissement",
    myExams: "Mon examen",
    auditMessage: "Motif d'approbation",
    otherOption: "Questions diverses",
    386: "Fichier de formation",
    noPublicAnswers: "Cet examen ne publiera pas la réponse",
    examCollected: "Questions d'essai",
    electiveCourses: "Cours au choix",
    teacherDescTips: "Veuillez saisir le profil de l'enseignant",
    currentState: "état actuel",
    examExplain: "Description de l'examen",
    noPublicResult: "Ce test ne sera pas publié",
    examLog: "Dossier d'examen",
    notFaceOutProduceHours: "Attribution de visage non hors production ( temps d' étude )",
    searchQuestionnaireTips: "Entrez le nom du questionnaire pour la recherche",
    fitLevel: "Convient au niveau de la modalité pédagogique",
    newTeacher: "Ajouter un enseignant",
    allLeave: "Tous les congés",
    noticeSearchTips: "Recherchez les nouvelles qui vous intéressent",
    htllo: "Bonjour.",
    learningExperience: "Cv d'apprentissage",
    empty: "Aucun.",
    recommendUnit: "Unité recommandée",
    leaveState: "état actuel",
    makeUpExam: "En attente d'examen",
    contact: "Coordonnées du contact",
    recommendSuccessTips: "Vous avez soumis avec succès l'enseignant recommandé, qui sera ajouté à la liste des enseignants après la validation",
    startQuestionnaire: "Commencez la réponse",
    haveTime: "Temps mort",
    searchTeacherTips: "Recherchez les enseignants qui vous intéressent",
    all: "Tout le monde",
    teachingExpertise: "Compétences pédagogiques",
    isRequired: "Cet élément est obligatoire",
    myOnlineCourse: "Ma classe thématique en ligne",
    searchTips: "Saisissez le nom du cours à rechercher",
    rulePhone: "S'il vous pla?t entrer le numéro de téléphone correct",
    noExams: "Pas d'examen pour le moment",
    annualAssessment: "évaluation annuelle",
    confirmDeleteTips: "Confirmer la suppression",
    pause: "Mise en ?uvre",
    assessmentIndex: "Indicateurs d' évaluation",
    myLeave: "Mon congé",
    deleteWrongQuestion: "Supprimer la mauvaise banque de questions",
    autoSaveSuccess: "Enregistrer automatiquement",
    name: "Nom",
    isOver: "Terminé",
    myNotice: "Mon message",
    workingIn: "Servir dans",
    fitBusinessTips: "Sélectionnez la ligne appropriée pour votre entreprise",
    onlineCenterLearnHours: "Apprentissage centralisé en ligne ( temps d' étude )",
    myCourse: "Mon cours",
    isCorrect: "Pour une solution positive",
    checkTeacherInfo: "Afficher l'enseignant",
    myCertificate: "Mon certificat",
    onlineSelfLearnHours: "Apprentissage autonome en ligne ( temps d' étude )",
    examHours: "Durée de l'examen",
    autoSaveFailed: "échec de l'enregistrement automatique",
    student: "Apprenant ",
    mathematics: "Mathématiques",
    teacherContactTips: "Veuillez entrer les coordonnées de l'enseignant",
    reExam: "Nouvel examen",
    teacherWorkUnitTips: "Veuillez saisir l'unité de mesure",
    teamLeader: "Chef d' équipe",
    delete: "supprimer",
    allExams: "Tous les examens",
    times: "Le deuxième",
    cancelButton: "Annuler ",
    ruleIsNumber: "Veuillez saisir un nombre",
    allCourses: "Tous les cours",
    systemNotice: "Alertes système",
    learnTo: "Apprendre à",
    onlineCourse: "Cours en ligne",
    questionnaireDate: "Heure du questionnaire",
    company: "Unité de mesure",
    searchFaceTips: "Recherchez les cours qui vous intéressent",
    teachingStyleTips: "S'il vous pla?t entrer le style de conférence de l'enseignant",
    isCompleted: "Terminé ( e )",
    outCompanyLearn: "Apprentissage à l'extérieur",
    hours: "Dans la barre d'outils",
    onlineLearning: "Apprentissage en ligne",
    headmaster: "Professeur de classe",
    ruleNumber: "Entrez un nombre entier compris entre 8 et 8 bits",
    teachingInfo: "Informations sur la session",
    userName: "Nom d'utilisateur",
    message: "Lettre privée",
    confirmDelete: "Supprimer la confirmation",
    chargeInfoTips: "Veuillez saisir un taux de facturation",
    searchOnlineTips: "Recherchez la classe thématique en ligne qui vous intéresse",
    marking: "Pendant le défilé",
    exams: "L'examen",
    myFaceCourse: "Mon cours de formation en face-à-face",
    highSchool: "Lycéens",
    pleaseSelect: "Veuillez sélectionner",
    leaveInfo: "Détails du congé",
    location: "Lieu de résidence",
    committeeMembers: "Organisation du comité d'inspection de la discipline",
    examOver: "L'examen est terminé",
    checkQuestionnaire: "Afficher le questionnaire"
  }
};